<div class="container">
  <div class="row h-100 justify-content-center mt-5">
    <div class="col col-12 log-box">
      <h3>Versand Statistik</h3>
      <app-sms-stats [smsStats]="monthlySmsStats$ | async" [limit]="smsLimit"></app-sms-stats>
    </div>
  </div>
</div>
